import { postApi } from "../../Shared/Services/RestService";
import {
  CompleteRegistrationRequest,
  RegistrationBeginRequest,
  UserRegisterResult,
  VerifyOtpRequest,
} from "../Types/UsersType";

export const beginRegistration = (payload: RegistrationBeginRequest) => {
  return postApi<UserRegisterResult>("/register", payload);
};

export const verifyRegistrationOtp = (payload: VerifyOtpRequest) => {
  return postApi<VerifyOtpRequest>("/register/verify-otp", payload);
};

export const completeRegistration = (payload: CompleteRegistrationRequest) => {
  return postApi<UserRegisterResult>("/register/complete", payload);
};
